"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// set chat to activated
function SET_ACTIVATED(state, value) {
    state.activated = value;
}
exports.SET_ACTIVATED = SET_ACTIVATED;
// set the availability of the chat service
function SET_AVAILABILITY(state, value) {
    state.available = value;
}
exports.SET_AVAILABILITY = SET_AVAILABILITY;
// set department id
function SET_DEPT_ID(state, value) {
    state.depId = value;
}
exports.SET_DEPT_ID = SET_DEPT_ID;
// track that the chat button was loaded
function SET_LOADED(state) {
    state.loaded = true;
}
exports.SET_LOADED = SET_LOADED;
// track that the conversion was tracked
function SET_TRACKED(state) {
    state.tracked = true;
}
exports.SET_TRACKED = SET_TRACKED;
exports.default = {
    SET_ACTIVATED: SET_ACTIVATED,
    SET_AVAILABILITY: SET_AVAILABILITY,
    SET_DEPT_ID: SET_DEPT_ID,
    SET_LOADED: SET_LOADED,
    SET_TRACKED: SET_TRACKED,
};
//# sourceMappingURL=mutations.js.map